import { render, staticRenderFns } from "./dicatamenOperativo.vue?vue&type=template&id=8344f858&scoped=true"
import script from "./dicatamenOperativo.vue?vue&type=script&lang=js"
export * from "./dicatamenOperativo.vue?vue&type=script&lang=js"
import style0 from "./dicatamenOperativo.vue?vue&type=style&index=0&id=8344f858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8344f858",
  null
  
)

export default component.exports